import axios from 'axios';
import { message } from 'antd';
import askClosedDayReason from '../../utils/closedDayReasonPrompt';
import { normalizePermissionError, normalizeDayClosingError, PERMISSION_DENIED_MESSAGE } from '../../utils/errorHandling';

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_APP_API_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const res = error?.response;
    // Closed day change from a source screen (Sales, Purchase, Returns, Loans): ask for a reason, then retry once.
    const cfg = error?.config;
    const method = String(cfg?.method || '').toLowerCase();
    if (
      res?.status === 409 &&
      res.data?.code === 'EDIT_REASON_REQUIRED' &&
      res.data?.can_edit_closed &&
      cfg &&
      !cfg._reasonRetried &&
      ['put', 'patch', 'delete'].includes(method) &&
      !String(cfg.url || '').includes('petty-cash') // Finance Cash has its own reason field
    ) {
      const day = res.data.closed_date ? new Date(res.data.closed_date + 'T00:00:00').toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : '';
      const reason = await askClosedDayReason(day);
      if (reason) {
        cfg._reasonRetried = true;
        cfg.params = { ...(cfg.params || {}), edit_reason: reason };
        return axiosInstance.request(cfg);
      }
    }
    if (res) normalizeDayClosingError(res.data);
    if (res && normalizePermissionError(res.status, res.data)) {
      message.error({ content: PERMISSION_DENIED_MESSAGE, key: 'permission-denied' });
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
